<template>
    <div id="data-list-thumb-view" class="data-list-container">
        <vs-table
                ref="table"
                :max-items="20"
                pagination
                search
                :data="permissions"
        >
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center">
                    <!-- ADD NEW -->
                    <div
                            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                            @click="addData"
                    >
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary disabled">Permissie toevoegen ((nog) niet beschikbaar, dus klikken werkt niet)</span>
                    </div>
                </div>

                <!-- ITEMS PER PAGE -->
                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">

                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <vs-dropdown-menu>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=25">
                            <span>25</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="id">id</vs-th>
                <vs-th sort-key="name">Naam</vs-th>
     §       </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr
                        :data="tr"
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                >
                    <vs-td>
                        <p class="permission-id">{{ tr.id }}</p>

                    </vs-td>

                    <vs-td>
                        <p class="permission-name">{{ tr.name }}</p>
                    </vs-td>
                </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>

<script>

    export default {
        components: {
        },
        data() {
            return {
                selected: [],
                permissions: [],
                itemsPerPage: 20,
                isMounted: false,
                addNewDataSidebar: false,
                sidebarData: {},
                total: 0,
                activeStaff: null,
                popupActive: false,
                createStaff: {},
            };
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx;
                }
                return 0;
            },
            queriedItems() {
                return this.$refs.table
                    ? this.$refs.table.queriedResults.length
                    : this.staff.length;
            },
            staffRoute() {
                if (this.$route.meta.staff) {
                    if (localStorage.getItem("stafftoken") !== null) {
                        return true;
                    }
                } else {
                    if (localStorage.getItem("stafftoken") !== null) {
                        return true;
                    }
                    return false;
                }
            },
            activeStaffTitle: function () {
                if (this.activeStaff !== null) {
                    return this.activeStaff.insertion !== null
                        ? this.activeStaff.firstname +
                        " " +
                        this.activeStaff.insertion +
                        " " +
                        this.activeStaff.lastname
                        : this.activeStaff.firstname + " " + this.activeStaff.lastname;
                }
            },
        },
        methods: {
            getPermissions() {
                let url = "https://staffapi.hebtrek.nl/v1/permissions";
                this.$http
                    .get(url, {
                        headers: {
                            Authorization: "Bearer " + this.$auth.token,
                        },
                    })
                    .then((response) => {
                        this.permissions = response.data;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
            addData() {
                // this.$events.fire("create-staff-modal");
            },
            editData(permission) {
                this.$events.fire('open-permission-modal', permission);
            },
            getStafftatusColor(status) {
                if (status === "on_hold") return "warning";
                if (status === "delivered") return "success";
                if (status === "canceled") return "danger";
                return "primary";
            },
            getPopularityColor(num) {
                if (num > 90) return "success";
                if (num > 70) return "primary";
                if (num >= 50) return "warning";
                if (num < 50) return "danger";
                return "primary";
            },
            toggleDataSidebar(val = false) {
                this.addNewDataSidebar = val;
            },
            getStatus(status) {
                if (status == 0) {
                    return "inactief";
                }
                if (status == 1) {
                    return "open";
                }
                if (status == 2) {
                    return "gesloten";
                }
                if (status == 3) {
                    return "Tijdelijk gesloten";
                }
                if (status == 4) {
                    return "Binnenkort geopend";
                }
            },
        },
        created() {},
        mounted() {
            this.getPermissions();
        },
    };
</script>

<style lang="scss">
    #data-list-thumb-view {
        .vs-con-table {
            .order-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap-reverse;
                margin-left: 1.5rem;
                margin-right: 1.5rem;

                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 1.3rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

                    td {
                        padding: 10px;

                        &:first-child {
                            border-top-left-radius: 0.5rem;
                            border-bottom-left-radius: 0.5rem;
                        }

                        &:last-child {
                            border-top-right-radius: 0.5rem;
                            border-bottom-right-radius: 0.5rem;
                        }

                        &.img-container {
                            width: 1rem;
                            background: #fff;

                            span {
                                display: flex;
                                justify-content: flex-start;
                            }

                            .order-img {
                                max-height: 100px;
                                max-width: 100px;
                            }
                        }
                    }

                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }

                th.td-check {
                    padding: 0 15px !important;
                }

                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
